var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gp2-qtl-table research-data-table-wrapper" },
    [
      _vm.rows.length
        ? [
            _c("VariantSifterTableSettings", {
              attrs: {
                "per-page": Number(_vm.perPageNumber),
                columns: _vm.tableColumns,
                "visible-columns": _vm.visibleColumns,
              },
              on: {
                "update:perPage": _vm.onPerPageUpdate,
                "export-csv": _vm.exportCsv,
                "export-json": _vm.exportJson,
                "update:columnVisible": _vm.onColumnVisibleUpdate,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "before",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "vks-data-table-view-total" },
                          [
                            _vm._v(
                              " Total rows: " +
                                _vm._s(
                                  _vm.displayRows.length.toLocaleString()
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1093982933
              ),
            }),
            _c(
              "div",
              { staticClass: "gp2-qtl-table-block" },
              [
                _c("div", { staticClass: "gp2-qtl-table-wrap" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "table table-sm research-data-table gp2-qtl-data-table",
                      attrs: { cellpadding: "0", cellspacing: "0" },
                    },
                    [
                      _c("thead", [
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              [
                                _c("b-icon", {
                                  staticStyle: {
                                    color: "#ffcc00",
                                    cursor: "pointer",
                                  },
                                  attrs: {
                                    icon: _vm.showStarredOnly
                                      ? "star-fill"
                                      : "star",
                                  },
                                  on: { click: _vm.toggleStarredOnly },
                                }),
                              ],
                              1
                            ),
                            _vm._l(_vm.visibleTableColumns, function (column) {
                              return _c(
                                "th",
                                {
                                  key: column,
                                  staticClass: "byor-tooltip sortable-th",
                                  class: _vm.getColumnId(column),
                                  on: {
                                    click: function ($event) {
                                      return _vm.applySorting(column)
                                    },
                                  },
                                },
                                [_c("span", [_vm._v(_vm._s(column))])]
                              )
                            }),
                          ],
                          2
                        ),
                      ]),
                      _c(
                        "tbody",
                        _vm._l(_vm.pagedRows, function (row, rowIndex) {
                          return _c(
                            "tr",
                            { key: _vm.rowKey(row, rowIndex) },
                            [
                              _c(
                                "td",
                                [
                                  _c("b-icon", {
                                    style: {
                                      color: _vm.isStarred(row)
                                        ? "#ffcc00"
                                        : "#aaaaaa",
                                      cursor: "pointer",
                                    },
                                    attrs: {
                                      icon: _vm.isStarred(row)
                                        ? "star-fill"
                                        : "star",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleStar(row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._l(
                                _vm.visibleTableColumns,
                                function (column) {
                                  return _c(
                                    "td",
                                    {
                                      key: `${_vm.rowKey(
                                        row,
                                        rowIndex
                                      )}-${column}`,
                                      class: _vm.getColumnId(column),
                                    },
                                    [
                                      _vm.isDirectionalColumn(column)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "gp2-qtl-effect",
                                              class: _vm.effectClass(
                                                _vm.directionValue(row)
                                              ),
                                            },
                                            [
                                              column === "Beta" &&
                                              _vm.effectMark(
                                                _vm.directionValue(row)
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "gp2-qtl-effect-mark",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.effectMark(
                                                            _vm.directionValue(
                                                              row
                                                            )
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatCell(row, column)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatCell(row, column)
                                              )
                                            ),
                                          ],
                                    ],
                                    2
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]),
                _vm.perPageNumber !== "0" && _vm.perPageNumber !== 0
                  ? _c("b-pagination", {
                      staticClass:
                        "pagination-sm justify-content-center gp2-qtl-pagination",
                      attrs: {
                        "total-rows": _vm.displayRows.length,
                        "per-page": Number(_vm.perPageNumber),
                      },
                      model: {
                        value: _vm.currentPage,
                        callback: function ($$v) {
                          _vm.currentPage = $$v
                        },
                        expression: "currentPage",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _c("div", { staticClass: "gp2-qtl-table-empty" }, [
            _vm._v(
              " No QTL rows match the current type, tissue, and p-value filters. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }